import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

let nextPanelBodyId = 0;

@Component({
  selector: 'app-course-navigation-panel',
  templateUrl: './course-navigation-panel.component.html',
  styleUrls: ['./course-navigation-panel.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, TranslateModule],
})
export class CourseNavigationPanelComponent {
  readonly collapsed = model(false);
  readonly panelBodyId = `course-navigation-panel-body-${nextPanelBodyId++}`;

  toggle(): void {
    this.collapsed.update(v => !v);
  }
}
